import PublicWizardConfiguration from './PublicWizardConfiguration'

export default PublicWizardConfiguration
